// The player's starting level: "Do you have a DUPR rating?" (owner
// 2026-09-27 — the old small link was missed) above our 1-10 skill bar.
// No → the bar as before. Yes → type the DUPR; the bar follows it (converted
// on the server the same way: level = 2 × DUPR − 2).
// value = { self_skill: number, dupr: string }
import { useState } from 'react';
import SkillSlider from './SkillSlider';
import { duprToLevel } from '../utils/skillLevels';

const isValidDupr = (n) => !Number.isNaN(n) && n >= 1 && n <= 8.5;

const DuprBadge = () => (
  <span style={{ display: 'inline-flex', background: '#1D4ED8', color: '#fff', fontWeight: 900, fontSize: 10,
    letterSpacing: 1, padding: '3px 7px', borderRadius: 4, verticalAlign: 2 }}>DUPR</span>
);

export default function SkillInput({ value, onChange, sliderId = 'skill-slider-input', testid = 'skill-input' }) {
  const [hasDupr, setHasDupr] = useState(!!value?.dupr);
  const dupr = value?.dupr ?? '';
  const num = parseFloat(dupr);
  const valid = isValidDupr(num);
  const level = value?.self_skill ?? 5;
  const fromDupr = hasDupr && valid;

  const choice = (on, color) => ({
    border: `1.5px solid ${on ? color : '#2A2A2A'}`, background: on ? `${color}12` : '#0A0A0A',
    color: on ? '#fff' : '#A3A3A3', borderRadius: 10, padding: '11px 8px', fontWeight: 800, fontSize: 13,
    cursor: 'pointer', transition: 'border-color .16s, background .16s',
  });

  return (
    <div data-testid={testid}>
      <div data-testid={`${testid}-question`}
        style={{ background: '#0F0F0F', border: '1px solid #2A2A2A', borderRadius: 12, padding: 14, marginTop: 4, marginBottom: 10 }}>
        <p style={{ margin: '0 0 10px', fontWeight: 800, fontSize: 15, color: '#fff' }}>
          Do you have a <DuprBadge /> rating?
        </p>
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 8 }}>
          <button type="button" data-testid={`${testid}-use-slider`} aria-pressed={!hasDupr}
            style={choice(!hasDupr, '#22C55E')}
            onClick={() => { setHasDupr(false); onChange({ self_skill: level, dupr: '' }); }}>
            No — I&apos;ll use the bar
          </button>
          <button type="button" data-testid={`${testid}-use-dupr`} aria-pressed={hasDupr}
            style={choice(hasDupr, '#3B82F6')}
            onClick={() => setHasDupr(true)}>
            Yes, I have one
          </button>
        </div>
        {hasDupr && (
          <div data-testid={`${testid}-dupr`} style={{ marginTop: 12 }}>
            <input data-testid={`${testid}-dupr-field`} inputMode="decimal" placeholder="Type it, e.g. 3.5"
              autoFocus value={dupr}
              onChange={e => {
                const v = e.target.value;
                const n = parseFloat(v);
                onChange({ dupr: v, self_skill: isValidDupr(n) ? duprToLevel(n) : level });
              }}
              style={{ width: '100%', background: '#0A0A0A', borderRadius: 8, padding: '11px 14px', color: '#fff',
                fontSize: 22, fontFamily: 'Oswald, sans-serif', outline: 'none',
                border: `1px solid ${dupr ? (valid ? '#3B82F6' : '#EF4444') : '#2A2A2A'}` }} />
            <p className="text-xs" style={{ margin: '8px 0 0', color: dupr && !valid ? '#EF4444' : '#A3A3A3' }}>
              {dupr && !valid ? 'DUPR ratings run from 2.0 to 8.0.'
                : valid ? <>✓ That&apos;s level <b style={{ color: '#fff' }}>{Math.round(duprToLevel(num))}</b> of 10.</>
                  : 'We turn it into our 1–10 level for fair pairing.'}
            </p>
            <p className="text-[11px]" style={{ margin: '4px 0 0', color: '#737373' }}>
              It&apos;s in the DUPR app under your name — use your doubles rating.
            </p>
          </div>
        )}
      </div>
      {fromDupr && (
        <p data-testid={`${testid}-from-dupr`} className="text-[11px]" style={{ margin: '0 0 4px', color: '#93C5FD' }}>
          Set from your DUPR {num} — tap No to adjust it yourself.
        </p>
      )}
      <SkillSlider value={level} sliderId={sliderId} disabled={fromDupr}
        onChange={v => onChange({ self_skill: v, dupr: '' })} />
    </div>
  );
}
